//import VAD from "vad";

import { toLowerCase } from "../utils/common_utils";

/**
 open ai realtime api's consume and produce
   24 KHZ, pcm 16, mono or 1 channel audio  
 */
export const Audio_SAMPLE_RATE=24000

/**
 * voice activity detection module, used for silence detection
 */
//const vad = new VAD(1); // Sensitivity level (1 = most sensitive, 3 = least)

/**
 * This API can return three possible results: granted, prompt or denied. 
 
 * If permissions are granted, we don't need to ask for them again, which can save us an extra code call. prompt is the default state, where the browser will ask the user for permission. However, the most useful state here is denied.

If the result is denied, that means the user has explicitly blocked this web page from accessing the microphone. It's useful to know this because we can then show a message telling the user they won't be able to use the web page without altering the permissions in their browser settings page
 */
export async function getMicrophonePermissions() {
  console.log("microphone permissions ",navigator?.permissions)
    if (!!navigator?.permissions) {
      return (
        navigator.permissions
          // @ts-ignore - ignore because microphone is not in the enum of name for all browsers
          ?.query({ name: 'microphone' })
          .then((result) => result.state)
          .catch((err) => {
            console.log(err)
            return 'prompt';
          })
      );
    }
    return 'prompt';
  }

  /**
   * tries to get permissions and asks if required
   * returns either granted or denied , no prompt state
   */
  export async function askAudioPermissions(){
    console.log("asking for audio permissions ")
    try{
      let permission=toLowerCase(
        await getMicrophonePermissions())
      console.log("audio permissions state "+permission)
      if(permission=='granted') return 'granted'
      
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(track => track.stop()); // Stop after getting permission
        //return fetchAudioPermissionState(); // Re-run after asking permission
        permission=toLowerCase(
          await getMicrophonePermissions())
        console.log("audio permissions state "+permission)
        if(permission=='granted') return 'granted'
        return "denied"
    }catch(err){
      console.log(err)
    }
  }

  export async function monitorMicrophonePermissionChanges(callback) {
    if (navigator.permissions) {
      try {
        // Query the microphone permission
        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
  
        // Initial state
       // console.log('Microphone permission state:', permissionStatus.state);
  
        // Listen for changes
        permissionStatus.onchange = () => {
         // console.log('Microphone permission changed to:', permissionStatus.state);
          if(callback)callback()
          // Handle state changes here (e.g., update UI or trigger actions)
        };
      } catch (error) {
        console.log('Error monitoring microphone permissions:', error);
      }
    } else {
      console.warn('Permissions API is not supported in this browser.');
    }
  }
  /**
   * listens to and update list of available microphone devices
   */
  export function monitorMicrophoneDeviceChanges(callback) {
    if (navigator.mediaDevices && navigator.mediaDevices.addEventListener) {
      // Listen for device changes
      navigator.mediaDevices.addEventListener('devicechange', async () => {
       // console.log('Media devices changed ');
        const audioInputs=await getMicrophoneDevices()
        if(callback)callback(audioInputs)
      });
    } else {
      console.warn('MediaDevices API is not supported in this browser.');
    }
  }
  
  export async function getMicrophoneDevices(){
    const devices = await navigator.mediaDevices.enumerateDevices();
        const audioInputs = devices.filter(device => device.kind === 'audioinput');
        console.log('Available audio devices:', audioInputs);
        return audioInputs
  }


/**
 * this processor ensures  PCM  mono output:
 * but we still need pcm 16 bit, so need to have tha as well
 * @returns 
 */
  export function get_audio_worklet_processor_module(){
     // Create the worklet processor code as a string
  const processorCode = `
  class AudioProcessor extends AudioWorkletProcessor {
    process(inputs, outputs, parameters) {
      const input = inputs[0];
      if (input) {
        this.port.postMessage(input[0]); // Post raw PCM data to the main thread
      }
      return true; // Keep the processor running
    }
  }
  registerProcessor('audio-processor', AudioProcessor);
`;

// Convert the code string to a Blob and create a Blob URL
const blob = new Blob([processorCode], 
    { type: 'application/javascript' });
const moduleUrl = URL.createObjectURL(blob);
return moduleUrl
}

// Helper function to convert ArrayBuffer audio to Base64 string
export function arrayBufferToBase64String(buffer) {
  let binary = '';
  let bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary); // Convert to Base64
}

export function float32ToInt16(float32Frame) {
  const int16 = new Int16Array(float32Frame.length);
  for (let i = 0; i < float32Frame.length; i++) {
    // clamp & scale
    int16[i] = Math.max(-32768, Math.min(32767, float32Frame[i] * 32767));
  }
  return int16;
}

/**  Silence detection parameters
 most noise is till 0.02 and human voice is 0.05 and above
 so 0.03 is a good threshold
*/
const SILENCE_THRESHOLD = 0.05; // Adjust this threshold based on your environment

/**
 * checks if the audio is silence or if someone is speaking
 * its a decent silence detecter
 */
export const detectSilence = (audioArrayBuffer) => {
  const audioData = getAudioDataFromArrayBuffer(audioArrayBuffer);
  const rms = calculateRMS(audioData);
  // Check if RMS is below the silence threshold
  if (rms < SILENCE_THRESHOLD) {
    return true;
  }
  return false;  // No silence detected
};

// Function to extract audio data (e.g., Int16Array) from the ArrayBuffer
const getAudioDataFromArrayBuffer = (arrayBuffer) => {
  const byteArray = new Int16Array(arrayBuffer);  // For PCM 16-bit audio
  return byteArray;
};

// Function to calculate the RMS (Root Mean Square) of audio data
const calculateRMS = (audioData) => {
  let sum = 0;
  for (let i = 0; i < audioData.length; i++) {
    const value = audioData[i] / 32768;  // Normalize to range [-1, 1] for PCM 16-bit audio
    sum += value * value;
  }
  return Math.sqrt(sum / audioData.length);
};

/*
export function isSilence(audioArr){
  if(!audioArr) return true
  try{
    vad.processAudio(audioArr, Audio_SAMPLE_RATE).then((res) => {
      if (res === "VAD_SILENCE") {
          console.log("Silence detected...");
          return true
      } else { 
          console.log("Speaking...");
          return false
      }
  });
  }catch(exception){
    console.log("exception occured in isSilence "+exception);
  }
  return false
}*/